
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zwei Gründe können dazu führen: Viele von uns haben unter der Woche einen ziemlich regelmässigen Schlaf-Wach-Rhythmus. Übers Wochenende verändert sich dieser meistens. Wir gehen Freitag- und Samstagnacht später ins Bett und schlafen dafür am Morgen länger. Darum sind wir am Sonntagabend weniger müde und schlafen schlechter ein. Aber auch Sorgen und Überlegungen, die die Arbeit betreffen, können dazu führen, dass man sich und seine Gedanken in der Nacht auf Montag hin und her wälzt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;